import {createSlice} from '@reduxjs/toolkit';
import {CareRecipientDetailsDto} from 'src/shared/services/care-recipients/dto/details-care-recipient-dto';

interface CareRecipientsInitialState {
  careRecipientDetails: CareRecipientDetailsDto | undefined;
  careRecipientsList?: Array<CareRecipientDetailsDto>;
  isCareRecipientsListLoading?: boolean;
}

const initialState: CareRecipientsInitialState = {
  careRecipientDetails: undefined,
  careRecipientsList: undefined,
  isCareRecipientsListLoading: false,
};

const careRecipientsSlice = createSlice({
  name: 'careRecipients',
  initialState: initialState,
  reducers: {
    setCareRecipientDetails: (state, action) => {
      state.careRecipientDetails = action.payload;
    },
    setCareRecipientsList: (state, action) => {
      state.careRecipientsList = action.payload;
    },
    setIsCareRecipientsListLoading: (state, action) => {
      state.isCareRecipientsListLoading = action.payload;
    },
  },
});

export const {
  setCareRecipientDetails,
  setCareRecipientsList,
  setIsCareRecipientsListLoading,
} = careRecipientsSlice.actions;

export default careRecipientsSlice.reducer;
